import useFeatureToggles from './useFeatureToggles';

export const useIsRjCommunicationHubEnabled = (): boolean => {
  const { isFeatureToggleEnabled } = useFeatureToggles();
  return isFeatureToggleEnabled((ft) => ft.RJ_COMMUNICATION_HUB);
};
